export enum UserRegistrationStatusEnum {
  Player = 'PLAYER',
  QuickReg = 'QUICK_REG',
  QuickOpen = 'QUICK_OPEN',
  QuickOpen2 = 'Quick Open'
};